<template>
  <v-card class="elevation-12">
    <v-toolbar color="white" dense>
      <img src="@/assets/logo.jpg" height="36px" width="200px" class="mr-3" />
      <v-icon color="primary">person</v-icon>
      <v-toolbar-title>Sign Up</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-progress-linear
        v-show="connecting"
        :indeterminate="true"
      ></v-progress-linear>
      <v-alert
        v-model="error"
        type="error"
        :dismissible="true"
        icon="warning"
        dark
      >
        {{ errorText }}
      </v-alert>
      <v-layout align-center justify-center>
        <v-flex xs12 sm10>
          <v-radio-group v-model="signUpType" :mandatory="false">
            <v-radio
              label="Register a company account"
              value="COMPANY"
            ></v-radio>
            <v-radio
              label="Register a personal account"
              value="PERSONAL"
            ></v-radio>
          </v-radio-group>
          <v-text-field
            v-model="companyName"
            label="Company Name"
            v-if="signUpType === 'COMPANY'"
            :error-messages="companyNameErrors"
            required
          ></v-text-field>
          <v-text-field
            v-model="firstName"
            label="First Name"
            v-if="signUpType === 'PERSONAL'"
            :error-messages="firstNameErrors"
            required
          ></v-text-field>
          <v-text-field
            v-model="lastName"
            label="Last Name"
            v-if="signUpType === 'PERSONAL'"
            :error-messages="lastNameErrors"
            required
          ></v-text-field>
          <v-text-field
            v-model="companyEmail"
            :label="emailLabel"
            :error-messages="companyEmailErrors"
            required
          ></v-text-field>
          <v-text-field
            v-model="companyPhone"
            :label="phoneLabel"
            :error-messages="companyPhoneErrors"
            size="10"
            mask="##########"
            counter="10"
            required
          ></v-text-field>
          <v-card
            v-if="signUpType === 'COMPANY'"
            style="margin-left: -10px; margin-right: -10px; margin-top: 10px; margin-bottom: 10px;"
          >
            <v-card-title primary-title>
              <div>
                <p class="mb-0">Contact Person Details</p>
                <v-checkbox
                  label="Use same as above"
                  hide-details
                  :disabled="connecting"
                  v-model="sameAsAbove"
                />
              </div>
            </v-card-title>
            <v-card-text>
              <v-text-field
                v-if="signUpType === 'COMPANY'"
                v-model="contactPerson"
                label="Contact Person"
                :error-messages="contactPersonErrors"
                required
              ></v-text-field>
              <v-text-field
                v-if="signUpType === 'COMPANY'"
                v-model="contactPersonEmail"
                label="Contact Person Email"
                :error-messages="contactPersonEmailErrors"
                required
              ></v-text-field>
              <v-text-field
                v-if="signUpType === 'COMPANY'"
                v-model="contactPersonPhone"
                label="Contact Person Phone"
                :error-messages="contactPersonPhoneErrors"
                size="10"
                mask="##########"
                counter="10"
                required
              ></v-text-field>
            </v-card-text>
          </v-card>
          <v-text-field
            :disabled="connecting"
            name="password"
            label="Enter Password"
            :error-messages="passwordErrors"
            v-model="password"
            required
            @keyup.enter="submit"
            :type="passwordVisibilityOff ? 'password' : 'text'"
          >
          </v-text-field>
          <v-text-field
            :disabled="connecting"
            name="passwordConfirm"
            :error-messages="passwordConfirmErrors"
            label="Confirm Password"
            v-model="passwordConfirm"
            required
            @keyup.enter="submit"
            :type="passwordVisibilityOff ? 'password' : 'text'"
          >
          </v-text-field>
          <div class="d-flex flex-row">
            <v-checkbox
              v-model="agreeToTermsAndConditions"
              required
              class="ma-0"
            ></v-checkbox>
            <p class="ma-0">
              I agree to Synergy Courier
              <span
                ><a
                  href="https://cube-messenger.com/terms-and-conditions"
                  target="_blank"
                  >Terms and Conditions</a
                ></span
              >
              and
              <span
                ><a
                  href="http://cube-messenger.com/privacy-policy"
                  target="_blank"
                  >Privacy Policy</a
                ></span
              >
            </p>
          </div>
          <v-checkbox
            v-if="signUpType === 'COMPANY'"
            v-model="iHavePermission"
            label="I have permission to create account on behalf of the company/organization"
          ></v-checkbox>
          <v-alert
            :value="confirmAuthorization"
            color="info"
            :dismissible="true"
            icon="info"
            outline
          >
            Confirm whether you are authorized
          </v-alert>
          <vue-recaptcha
            ref="recaptcha"
            @verify="onVerify"
            @expired="onExpired"
            sitekey="6LdxLasZAAAAAExdJAN_HOz5efPuek-dnFBr_d5J"
          ></vue-recaptcha>
          <v-layout row wrap align-baseline>
            <v-flex xs12 text-xs-center>
              <v-btn
                @click="submit"
                color="primary"
                block
                :disabled="
                  !valid ||
                    connecting ||
                    !verified ||
                    !agreeToTermsAndConditions
                "
              >
                Sign Up
              </v-btn>
            </v-flex>
            <v-flex xs12 text-xs-center>
              <p>
                Have an account already?
                <span
                  ><v-btn
                    flat
                    small
                    @click="$router.push({ name: 'signIn', params: {} })"
                    >Login</v-btn
                  ></span
                >
              </p>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<style scoped>
/*#sign-in-card {
      position: absolute;
      right: 15px;
      top: 85px;
      width: 30%;
  }*/
</style>
<script type="text/javascript">
import EventBus from '../event-bus'
import VueRecaptcha from 'vue-recaptcha'
import { required, email, sameAs, minLength } from 'vuelidate/lib/validators'

export default {
  name: 'SignUp',
  components: {
    VueRecaptcha
  },
  data() {
    return {
      passwordVisibilityOff: true,
      error: null,
      rememberMe: false,
      errorText: '',
      signUpType: 'COMPANY',
      companyEmail: '',
      contactPersonEmail: '',
      contactPersonPhone: '',
      companyName: '',
      firstName: '',
      lastName: '',
      companyPhone: '',
      contactPerson: '',
      password: '',
      passwordConfirm: '',
      connecting: false,
      iHavePermission: false,
      confirmAuthorization: false,
      agreeToTermsAndConditions: false,
      verified: false,
      sameAsAbove: false
    }
  },
  validations() {
    if (this.signUpType === 'COMPANY') {
      return {
        companyName: {
          required
        },
        companyEmail: {
          required,
          email
        },
        contactPersonEmail: {
          required,
          email
        },
        contactPersonPhone: {
          required,
          minLength: minLength(10)
        },
        companyPhone: {
          required,
          minLength: minLength(10)
        },
        contactPerson: {
          required
        },
        password: {
          required
        },
        passwordConfirm: {
          sameAsPassword: sameAs('password')
        }
      }
    } else {
      return {
        firstName: {
          required
        },
        lastName: {
          required
        },
        companyEmail: {
          required,
          email
        },
        companyPhone: {
          required,
          minLength: minLength(10)
        },
        password: {
          required
        },
        passwordConfirm: {
          sameAsPassword: sameAs('password')
        }
      }
    }
  },
  watch: {
    sameAsAbove(newValue, oldValue) {
      if (newValue) {
        this.contactPersonEmail = this.companyEmail
        this.contactPersonPhone = this.companyPhone
        this.contactPerson = this.companyName
      }
    }
  },
  computed: {
    emailLabel() {
      if (this.signUpType === 'COMPANY') return 'Company Email'
      else return 'Your Email'
    },
    phoneLabel() {
      if (this.signUpType === 'COMPANY') return 'Company Phone'
      else return 'Your Phone'
    },
    valid() {
      return true
    },
    companyNameErrors() {
      const errors = []
      if (!this.$v.companyName.$dirty) return errors
      !this.$v.companyName.required && errors.push('This field is required')
      return errors
    },
    firstNameErrors() {
      const errors = []
      if (!this.$v.firstName.$dirty) return errors
      !this.$v.firstName.required && errors.push('This field is required')
      return errors
    },
    lastNameErrors() {
      const errors = []
      if (!this.$v.lastName.$dirty) return errors
      !this.$v.lastName.required && errors.push('This field is required')
      return errors
    },
    companyEmailErrors() {
      const errors = []
      if (!this.$v.companyEmail.$dirty) return errors
      !this.$v.companyEmail.required && errors.push('Email is required')
      !this.$v.companyEmail.email && errors.push('Enter a valid email')
      return errors
    },
    contactPersonEmailErrors() {
      const errors = []
      if (!this.$v.contactPersonEmail.$dirty) return errors
      !this.$v.contactPersonEmail.required &&
        errors.push('Contact person email is required')
      !this.$v.contactPersonEmail.email && errors.push('Enter a valid email')
      return errors
    },
    contactPersonPhoneErrors() {
      const errors = []
      if (!this.$v.contactPersonPhone.$dirty) return errors
      !this.$v.contactPersonPhone.required &&
        errors.push('Enter a valid phone number')
      !this.$v.contactPersonPhone.minLength &&
        errors.push('Enter a valid phone number')
      return errors
    },
    companyPhoneErrors() {
      const errors = []
      if (!this.$v.companyPhone.$dirty) return errors
      !this.$v.companyPhone.required &&
        errors.push('Enter a valid phone number')
      !this.$v.companyPhone.minLength &&
        errors.push('Enter a valid phone number')
      return errors
    },
    contactPersonErrors() {
      const errors = []
      if (!this.$v.contactPerson.$dirty) {
        return errors
      }
      !this.$v.contactPerson.required &&
        errors.push('Enter name of contact person')
      return errors
    },
    passwordErrors() {
      const errors = []
      if (!this.$v.password.$dirty) return errors
      !this.$v.password.required && errors.push('Enter the password')
      return errors
    },
    passwordConfirmErrors() {
      const errors = []
      if (!this.$v.passwordConfirm.$dirty) return errors
      !this.$v.passwordConfirm.sameAsPassword &&
        errors.push('Passwords do not match')
      return errors
    }
  },
  methods: {
    onVerify: function(response) {
      this.verified = true
    },
    onExpired: function() {
      this.verified = false
    },
    validEmail: function(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    submit() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$app.log('There errors')
      } else if (!this.iHavePermission && this.signUpType === 'COMPANY') {
        this.confirmAuthorization = true
      } else {
        // Native form submission is not yet supported
        this.error = false
        this.connecting = true
        let theName =
          this.signUpType === 'COMPANY'
            ? this.companyName
            : this.firstName + ' ' + this.lastName
        if (this.signUpType === 'COMPANY') {
          this.contactPersonEmail = this.companyEmail
          this.contactPersonPhone = this.companyPhone
        }
        this.$auth.register({
          data: {
            name: theName,
            email: this.companyEmail,
            phone: this.companyPhone,
            contactPersonName: this.contactPerson
              ? this.contactPerson
              : theName,
            type: this.signUpType,
            contactPersonEmail: this.contactPersonEmail,
            contactPersonPhone: this.contactPersonPhone,
            password: this.password,
            password_confirmation: this.passwordConfirm,
            withVariables: true,
            signInId: this.companyEmail
          },
          // redirect: { name: 'user-account' },
          // remember: 'Rob',
          // staySignedIn: true,
          // autoLogin: true,
          // fetchUser: true,
          // rememberMe: true,
          success(response) {
            // this.$app.log(response.data.data)
            this.connecting = false
            EventBus.$emit(this.$actions.signedUp)
            this.$notify({
              group: 'all',
              title: 'Sign',
              text: 'You have signed registered!'
            })
          },
          error(error) {
            this.error = true
            this.connecting = false
            if (error.response) {
              if (error.response.status === 422) {
                switch (error.response.data.meta.code) {
                  case 'VALIDATION':
                    this.errorText = error.response.data.data
                    break
                  default:
                    this.errorText = error.response.data.meta.message
                }
              } else {
                this.errorText = error.response.data
              }
            } else {
              this.errorText = 'An error occurred ' + error.message
            }
          }
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SignUp.vue